import {Component, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {Observable} from 'rxjs';
import {selectBulletinBoardPostSeenByInfo} from '@app/core/store/selectors/bulletin-board.selectors';
import {User} from '@app/core/models/user.model';
import {MatDialogRef} from '@angular/material/dialog';
import {BulletinPostsComponent} from '@app/modules/shared/components/bulletin-posts/bulletin-posts.component';

@Component({
	selector: 'app-bulletin-board-post-seen-by-info',
	templateUrl: './bulletin-board-post-seen-by-info.component.html',
	styleUrls: ['./bulletin-board-post-seen-by-info.component.scss'],
})
export class BulletinBoardPostSeenByInfoComponent implements OnInit {
	public postSeenByInfo$: Observable<User[]> = this.store.select(selectBulletinBoardPostSeenByInfo);

	constructor(
		private store: Store<IAppState>,
		private dialogRef: MatDialogRef<BulletinPostsComponent>,
	) {
	}

	public ngOnInit(): void {
	}

	public close(): void {
		this.dialogRef.close();
	}
}
